import React from 'react';
import Image from './dom-elements/Image';
// REDUX
import { connect } from 'react-redux';

const SocialIcons = (props) => {
  const SocialLinks = props.socialLinks.map((item, i) =>
    <li className={'social-item'} key={item.channel + i}>
      <a className={'social-link'} target="_blank" href={item.link}>
        <Image source={item.icon}/>
      </a>
      <style jsx>{`
        .social-item {
          width: 1.8rem;
          height: 1.8rem;
          margin: 0 1rem;
        }
      `}</style>
    </li>
  );
  return (
    <ul className={'social-links'}>
      {SocialLinks}
      <style jsx>{`
        .social-links {
          list-style: none;
          display: flex;
          flex-direction: row;
          justify-content: center;
          width: 100%;
        }
      `}</style>
    </ul>
  );
};

const mapStateToProps = (state) => {
  return {
    socialLinks: state.staticContent.homeData.data.social_links
  };
};

export default connect(mapStateToProps)(SocialIcons);



// WEBPACK FOOTER //
// ./src/components/SocialIcons.js